<template>
  <div class="simple-year-picker">
    <b-form-select
      v-model="inputVal"
      :options="yearOptions"
      :name="name"
      :disabled="readonly || disabled"
      :placeholder="placeholder"
      @change="onChange"
    />
    <div class="clear" />
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      inputVal: '',
      yearOptions: []
    }
  },
  watch: {
    value: {
      handler: function(newVal) {
        this.inputVal = newVal
      }
    }
  },
  created() {
    this.yearOptions.push({
      text:
        this.$t('common.text.date_year') + this.$t('common.placeholder.select'),
      value: ''
    })
    const currentDate = new Date()
    for (
      let i = currentDate.getFullYear();
      i >= currentDate.getFullYear() - 100;
      i--
    ) {
      this.yearOptions.push({
        text: i,
        value: '' + i
      })
    }
  },
  mounted() {
    this.inputVal = this.value
    if (!this.inputVal) {
      this.inputVal = ''
    }
  },
  methods: {
    hasError(name) {
      return this.errors.has(name)
    },
    onChange() {
      this.$emit('input', this.inputVal)
      this.$emit('change', this.inputVal)
      this.$emit('forceUpdate')
    }
  }
}
</script>

<style scoped>
.simple-year-picker {
  min-height: 49px;
}
</style>
